import { InMemoryTokenStore, createApiClient } from "@starter/core";

/**
 * Câblage applicatif — le seul endroit du repo qui connaisse l'environnement.
 *
 * `core` ne lit jamais `import.meta.env` : il reste ainsi testable sans Vite, et l'URL du
 * back n'est définie qu'ici.
 */

/** Session en mémoire. Le refresh token, lui, vit dans un cookie `HttpOnly` posé par le back. */
export const tokenStore = new InMemoryTokenStore();

/** Client HTTP typé, généré depuis le contrat OpenAPI gelé. */
export const api = createApiClient({
  baseUrl: import.meta.env.VITE_API_BASE_URL,
  tokenStore,
  // Refresh définitivement refusé : la session est morte, on renvoie vers la connexion.
  onSessionExpired: () => navigate("/login"),
});

/**
 * Navigation programmatique.
 *
 * `@lit-labs/router` écoute `popstate`, que `pushState` **ne déclenche pas** tout seul —
 * d'où l'événement explicite. Centralisé ici pour que personne n'ait à s'en souvenir.
 */
export function navigate(path: string): void {
  if (window.location.pathname === path) return;
  window.history.pushState({}, "", path);
  window.dispatchEvent(new PopStateEvent("popstate"));
}
